export default "__VITE_ASSET__oWQvbSGo__"